import React from "react";
import { UserEditPage, USER_TYPES } from "../../modules/user-management";

const SystemUserEdit = () => (
  <UserEditPage userType={USER_TYPES.SYSTEM} />
);

export default SystemUserEdit;
